<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Visualizar Informações Pessoais</h4>
        <p class="category">Atualize seus dados</p>
      </md-card-header>

      <md-card-content>
        <h4 class="title">Cliente</h4>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nome</label>
              <md-input :value="user.name" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>CPF / CNPJ</label>
              <md-input :value="user.taxId" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>RG / IE</label>
              <md-input :value="user.identityCard" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Telefones</label>
              <md-select
                v-model="selectedPhone"
                name="phones"
                placeholder="Telefones"
              >
                <md-option v-for="phone in phones" :key="phone" :value="phone">
                  {{ phone }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Email</label>
              <md-input :value="user.email" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Email Financeiro</label>
              <md-input :value="user.emailF" disabled></md-input>
            </md-field>
          </div>

          <h4 class="title">Localização</h4>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Endereço</label>
              <md-input :value="user.address" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Cidade</label>
              <md-input :value="user.city" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Bairro</label>
              <md-input :value="user.district" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>CEP</label>
              <md-input :value="user.zipCode" disabled></md-input>
            </md-field>
          </div>

          <h4 class="title">Endereço de Cobrança</h4>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Endereço</label>
              <md-input :value="user.addressF" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Cidade</label>
              <md-input :value="user.cityF" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Bairro</label>
              <md-input :value="user.districtF" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>CEP</label>
              <md-input :value="user.zipCodeF" disabled></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
export default {
  name: "edit-profile-form",
  computed: {
    user() {
      return this.$store.getters.user;
    },
    phones() {
      const phones = [];

      if (this.user.tel1) {
        phones.push(`${this.user.ddd1}${this.user.tel1}`);
      }
      if (this.user.tel2) {
        phones.push(`${this.user.ddd2}${this.user.tel2}`);
      }
      if (this.user.tel3) {
        phones.push(`${this.user.ddd3}${this.user.tel3}`);
      }
      if (this.user.tel4) {
        phones.push(`${this.user.ddd4}${this.user.tel4}`);
      }
      if (this.user.tel5) {
        phones.push(`${this.user.ddd5}${this.user.tel5}`);
      }
      if (this.user.tel6) {
        phones.push(`${this.user.ddd6}${this.user.tel6}`);
      }

      return [...new Set(phones)];
    }
  },
  props: {
    dataBackgroundColor: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      selectedPhone: null
    };
  },
  mounted() {
    this.selectedPhone = this.phones[0];
  }
};
</script>
<style></style>
